{
  "loader": {
    "retry": {
      "message": "Ładowanie nie powiodło się..."
    }
  },
  "notifications": {
    "invalidStore": "Nieprawidłowy sklep. Przełączono na domyślny sklep.",
    "invalidAisles": "Nieprawidłowe alejki. Przełączono na domyślną wartość filtra.",
    "invalidDepartments": "Nieprawidłowe działy. Przełączono na domyślną wartość filtra.",
    "invalidTimeRange": "Nieprawidłowy zakres czasu. Przełączono na domyślny.",
    "storeAccessChanged": "Dostęp do sklepu zmieniony. Zaloguj się ponownie."
  },
  "status": {
    "active": "aktywny",
    "inactive": "nieaktywny",
    "deleted": "usunięty"
  }
}
